import { FlatTreeControl } from '@angular/cdk/tree';
import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTreeFlattener } from '@angular/material/tree';
import { StaffInTeam } from '@app/models/groupEntitiesData.model';
import { Staff } from '@app/models/staff.model';
import { eqSet } from '@app/shared/common/utils';
import { DataSelectors } from '@app/store/data/data.selectors';
import { Select } from '@ngxs/store';
import { map, Observable, startWith } from 'rxjs';
import { StaffSearchComponent } from '../staff-search/staff-search.component';
import { sortBy, chain } from 'lodash';
@Component({
    selector: 'app-staff-in-team-search',
    templateUrl: './staff-in-team-search.component.html',
    styleUrls: ['./staff-in-team-search.component.scss']
})
export class StaffInTeamSearchComponent extends StaffSearchComponent implements OnInit, AfterContentInit {
    @Input() allowNull?: boolean = true;
    @Output() staffsChange = new EventEmitter<Staff[]>();
    @Input() selectedId: string[] = [];
    @Input() multiple: boolean = false;
    @Select(DataSelectors.staffTeamList) team$!: Observable<StaffInTeam>;
    _teamSelected: string[] = [];
    disabledEmpty: boolean = false;
    startRender: boolean = false;
    _cachedGrp: Set<string> = new Set<string>([]);
    override get staffList(): Staff[] {
        const list = this.staffService.staffList;
        // let _staffList = this.disabledEmpty ? list : [emptyStaff, ...list];
        return list;
    }
    get configList() {
        return [];
        // return this.allowNull ? [emptyStaff] : [];
    }
    get displayStaff() {
        if (this._teamSelected?.length > 0) {
            return [...this.configList, ...this.staffList.filter(x => this._teamSelected.some(stfcd => stfcd === x.stfcd))];
        }
        return [...this.configList, ...this.staffList]
    }

    ngAfterContentInit(): void {
        // throw new Error('Method not implemented.');
        setTimeout(() => {
            this.cd.detectChanges();
            this.filtered$ = this.form.valueChanges.pipe(
                startWith(''),
                map(
                    (value) => { return (this.displayStaff?.filter((staff) => staff.name.includes(value)) ?? []); }
                )
            );
            this.startRender = true;
            this.cd.detectChanges();
        });
    }

    staffInGroupRender: any[] = [];
    ngOnInit(): void {
        this.team$.subscribe(() => {
            const staffinteam = this.staffService.teamList;
            const newList = staffinteam.map(x => x.objcd);
            const newSet = new Set<string>(newList);
            if (staffinteam && staffinteam.length > 0 && !eqSet(this._cachedGrp, newSet)) {
                this.staffInGroupRender = this.readDataGrp(staffinteam);
                this._cachedGrp = newSet;
            }
        })


    }

    readDataGrp(grpData: any[] = []) {
        grpData = sortBy(grpData, ['blockcd', 'unitcd', 'sortNO_TEAMKBN'], ['asc', 'asc', 'asc']);
        const _grpData = chain(grpData)
            .groupBy((grp: any) => { return grp.corpcd + grp.officecd + grp.blockcd + grp.subcd + grp.unitcd + grp.teamkbncd; })
            .map((grpGroup: any) => {
                const group_grp = chain(grpGroup)
                    .groupBy((groupByGrp: any) => { return this.generateGrpUnit(groupByGrp); })
                    .map((item: any) => {
                        return {
                            grpunit: this.generateGrpUnit(item[0]),
                            grpnm: item[0].teamnm,
                            grpcd: item[0].teamcd,
                            daiCdList: item.map((x: any) => { return x.objcd; }),
                        };
                    })
                    .value();
                return {
                    grpkbncd: grpGroup[0].teamkbncd,
                    grpkbnnm: grpGroup[0].teamkbnnm,
                    grps: group_grp
                };
            })
            .value();
        if (_grpData && _grpData.length > 0) {
            const result = _grpData.map((item: any, index, arr) => {
                if (index === arr.length - 1) {
                    item.last = true;
                }
                if (item.grps && item.grps.length > 0) {
                    item.grps = item.grps.map((child: any, _index: number, _arr: any) => {
                        return { ...child, last: _index === _arr.length - 1 ? true : false, lastParent: item.last ? true : false };
                    });
                }
                return item;
            });
            return result;
        }
        return [];
    }

    generateGrpUnit(element: any) {
        if (!element) return undefined;
        return element.corpcd
            + element.officecd
            + element.blockcd
            + element.subcd
            + element.unitcd
            + element.teamkbncd
            + element.teamcd;
    }

    private _transformer = (node: any, level: number) => {
        return {
            expandable: !!node.grps && node.grps.length > 0,
            name: node.grpkbnnm || node.grpnm,
            level: level,
            grpunit: node.grpunit || undefined,
            grpcd: node.grpcd || undefined,
            last: node.last || false,
            lastParent: node.lastParent || false,
        };
    };

    treeControl = new FlatTreeControl<any>(
        node => node.level,
        node => node.expandable,
    );
    treeFlattener = new MatTreeFlattener(
        this._transformer,
        node => node.level,
        node => node.expandable,
        node => node.grps,
    );

    listControl(isEmpty: boolean, isFull: boolean) {
        if (isEmpty) {
            // only uncheck filtered data
            this.selectedId = this.selectedId.filter(stfcd => !this.staffList.some(x => x.stfcd === stfcd));
        }
        if (isFull) {
            let _selectedId = [...this.staffList.map(x => x.stfcd), ...this.selectedId];
            // unique only
            this.selectedId = [...new Set(_selectedId)];
        }
        this.getStaffChange();
    }

    override onChange(staff: Staff): void {
        //
        if (!staff.stfcd) return;
        if (!this.multiple) {
            this.selectedId = [staff.stfcd];
        } else {
            if (this.selectedId.length === 0) {
                this.selectedId = [staff.stfcd];
            } else {
                let index = this.selectedId.findIndex(x => x === staff.stfcd);
                if (index >= 0) {
                    this.selectedId.splice(index, 1);
                }
                else {
                    this.selectedId.push(staff.stfcd);
                }
            }
        }
        this.getStaffChange();
    }

    getStaffChange(): void {
        let staffs = this.staffList.filter(staff => this.selectedId.some(x => x === staff.stfcd));
        this.staffsChange.emit(staffs);
    }

    checkSelect(stfcd: string): boolean {
        return this.selectedId.some(x => x === stfcd);
    }

    filterByTeam(node: any) {
        if (!node || !node.grpcd || node.grpcd === '') {
            this._teamSelected = [];
            this.disabledEmpty = false;
        } else {
            let { grpunit } = node;
            this._teamSelected = this.staffService.teamList.filter(x => this.generateGrpUnit(x) === grpunit).map(x => x.objcd);
            this.disabledEmpty = true;
        }
        this.form.setValue(this.form.value);
        this.getStaffChange();
    }
}
